
import { useState, useEffect } from "react";
import { Plane } from "lucide-react";
import { SidebarHeader } from "@/components/ui/sidebar";

export function AppSidebarHeader() {
  const [siteTitle, setSiteTitle] = useState('نظام السياحة');

  useEffect(() => {
    const savedTitle = localStorage.getItem('site-title');
    if (savedTitle) {
      setSiteTitle(savedTitle);
    }
  }, []);

  return (
    <SidebarHeader className="p-5 md:p-6 border-b border-border/50 bg-gradient-to-br from-background to-muted/30">
      <div className="flex items-center gap-3 md:gap-4 group">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-primary via-purple-500 to-emerald-500 rounded-xl md:rounded-2xl opacity-75 blur-sm group-hover:opacity-100 transition-opacity duration-500"></div>
          <div className="relative w-11 h-11 md:w-14 md:h-14 bg-gradient-to-br from-primary via-purple-600 to-emerald-600 rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-500 group-hover:scale-105">
            <Plane className="w-5 h-5 md:w-7 md:h-7 text-white drop-shadow-md" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="font-bold bg-gradient-to-r from-foreground via-foreground to-muted-foreground bg-clip-text text-transparent text-base md:text-xl truncate">
            {siteTitle}
          </h2>
          <p className="text-xs text-muted-foreground mt-0.5 hidden md:block">نظام إدارة متقدم</p>
        </div>
      </div>
    </SidebarHeader>
  );
}
